import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {TenantFilter} from 'src/app/models/tenant/tenant';
import {RouterSegments} from 'src/app/models/router-segments';
import {AuthService} from 'src/app/services/auth/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DropdownFilterGroup} from 'src/app/models/filter/dropdown-filter';
import {SidenavService} from 'src/app/services/util/sidenav.service';
import {MatDialog} from '@angular/material/dialog';
import {TenantDetailCostMetric} from 'src/app/models/cost/tenant-cost-metric';
import {CostMgmtService} from 'src/app/services/api/cost-mgmt-service';

@Component({
    selector: 'app-tenant-cost-details',
    templateUrl: './tenant-cost-details.component.html',
    styleUrls: ['./tenant-cost-details.component.scss'],
    standalone: false
})
export class TenantCostDetailsComponent  implements OnInit {
private destroyRef = inject(DestroyRef);
  basepath = RouterSegments.COSTMGMT;
  basetenant: string;
  tenant: string;
  dataLoaded = false;
  costMetrics: TenantDetailCostMetric;
  filteredCostMetrics: TenantDetailCostMetric;
  totalSubscription = 0;
  fullTextSearch: TenantFilter;
  tags: TenantFilter;
  filterGroups: DropdownFilterGroup[];

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private authService: AuthService,
              private costMgmtService: CostMgmtService, private sidenavService: SidenavService, private matDialog: MatDialog) {
  }

  ngOnInit(): void {

    this.basetenant = this.authService.principal.provider;
    this.tenant = this.activatedRoute.snapshot.params.tenantId;
    console.log(this.basetenant);
    console.log(this.basepath);
    this.loadTenantDetailsCost();

  }

  private loadTenantDetailsCost() {
    this.costMgmtService.getTenantDetailCostMetric(this.tenant).subscribe(costMetrics => {

      // this.costMetrics = costMetrics.sort(this.tenantComparator);
      this.costMetrics = costMetrics;
      this.dataLoaded = true;
      this.filteredCostMetrics = costMetrics;
      // this.totalSubscription = this.costMetrics.length
      // console.table(this.tenants);
    });

  }

  // private tenantComparator(fsv: TenantDetailCostMetric, ssv: TenantDetailCostMetric): number {
  //   if (fsv. < ssv.createdDate) {
  //     return 1;
  //   } else {
  //     return -1
  //   }
  // }

  // loadTenantsSearchFilterDetails(fullTextSearch?: string): void {
  //   if (!fullTextSearch || fullTextSearch.trim().length < 3) {
  //     fullTextSearch = undefined;
  //   }
  //   this.fullTextSearch = {
  //     fullTextSearch
  //   };
  //   this.resetPage();
  // }

  // resetPage(): void {
  //   if (this.fullTextSearch.fullTextSearch) {
  //     this.filteredCostMetrics = this.costMetrics.filter(t =>
  //       t.tenantId.toLowerCase().match(this.fullTextSearch.fullTextSearch.toLowerCase())
  //     );
  //     // this.totalSubscription = this.filteredCostMetrics.length;
  //   } else {
  //     this.filteredCostMetrics = this.costMetrics;
  //     // this.totalSubscription = this.filteredCostMetrics.length;
  //   }
  // }


}
